import { trimStart } from "lodash";

export function isTrue(val:string | undefined){
    if(!val) return false;

    return val.toLowerCase() === 'true';
}

export function isFalse(val:string | undefined){
    return !isTrue(val);
}

export function assetUrl(val?: string) {
    return `${process.env.PUBLIC_PATH || ''}/${trimStart(val, '/')}`;
}